module.exports = __webpack_public_path__ + "img/1.9d4fcc67.png";